import {
  CommentIc,
  ExternalLink,
  Image,
  MapPinIc,
  ThumbIc,
  Video,
} from "@/components/Elements";
import { useEffect, useState } from "react";
import { mapStringToLocation, useLocation } from "@/hooks/useLocation";
import { themeTextColor } from "@/utils/colorConstant";
import { AdvertModel } from "../../types";
import { ActionBtn, DeleteButton } from "@/features/misc/components";
import { useFormat } from "@/hooks";
import { FileModel } from "@/types/common";
import AdvertAction from "./AdvertAction";
import { useDeleteAdvertMutation } from "../../api/merchant";
import { UserCarousel } from "@/components/Carousel";

export const AdvertDetail = ({
  advertDetail,
}: {
  advertDetail: AdvertModel;
}) => {
  const {
    createdOn: createdOn,
    description,
    files,
    likeCount: noOfLikes,
    commentCount,
    postId,
    postLocation,
    externalLinks,
    price,
    discount,
    postStatus,
    category,
    subCategory,
  } = advertDetail;
  const [address, setAddress] = useState("");
  const { getAddressDetail, geocoder } = useLocation();
  const { formatCost } = useFormat();
  const [deleteAdvert] = useDeleteAdvertMutation();

  useEffect(() => {
    if (postLocation) {
      (async () => {
        const location = mapStringToLocation(postLocation);
        if (location) {
          const { postCode } = await getAddressDetail(location);
          setAddress(postCode ?? "");
        }
      })();
    }
  }, [geocoder, postLocation]);

  const handleDelete = () => {
    deleteAdvert(postId);
  };

  return (
    <div className="w-[50vw]">
      <div className="flex justify-between">
        <div>{createdOn}</div>
        <div className="flex">
          <AdvertAction postId={postId} status={postStatus} />
          <div className="ml-[15px] flex items-center">
            <DeleteButton
              message="Are you sure, you want to delete this advert?"
              handleDelete={handleDelete}
            />
          </div>
        </div>
      </div>
      {files && files.length > 0 && (
        <div className="mt-4">
          <UserCarousel>
            {files.map((f: FileModel, index: number) => (
              <div key={`f${index}`} className="h-80">
                {f.fileUrl?.includes(".mp4") ? (
                  <Video apiSrc={f.fileUrl} className="w-full h-full" />
                ) : (
                  <Image src={f.fileUrl} className="w-full h-full" isApiUrl />
                )}
              </div>
            ))}
          </UserCarousel>
        </div>
      )}
      <p>{description}</p>
      <div className="mt-7 border-y border-black border-dotted flex justify-between py-2">
        <div className="text-sm">
          <span className="font-bold">Category:</span> {category}
        </div>
        <div className="text-sm">
          <span className="font-bold">Sub-Category:</span> {subCategory}
        </div>
        <div className="text-sm">
          <span className="font-bold">Price:</span> {formatCost(price)}
        </div>
        <div className="text-sm">
          <span className="font-bold">Discount:</span> {formatCost(discount)}
        </div>
      </div>
      {externalLinks?.split(`,`).map((link, index) => (
        <ExternalLink uri={link} key={`L${index}`} />
      ))}
      <div className="flex justify-between py-5 border-b">
        <ActionBtn text={noOfLikes}>
          <ThumbIc className={`w-6 h-6 ${themeTextColor}`} />
        </ActionBtn>
        <ActionBtn text={address}>
          <MapPinIc className={`w-6 h-6  ${themeTextColor}`} />
        </ActionBtn>
        <ActionBtn text={commentCount}>
          <CommentIc className={`w-6 h-6  ${themeTextColor}`} />
        </ActionBtn>
      </div>
    </div>
  );
};
